// @ngInject
function AuthService($rootScope, $cookies, $location, DS, DSHttpAdapter, $q, $state,$window, ToasterService, UsersApiService,apiToken,LoginDialogService, ResourcesService, $translate) {
    var _isAuthenticating = false;
    var _isAuthenticated = false;
    var _user = null;
    return {
        isAuthenticated: isAuthenticated,
        hasToken: hasToken,
        canAccess: canAccess,
        hasUser: hasUser,
        getUser: getUser,
        setToken: setToken,
        showLogin: showLogin,
        logOut: logOut,
        matchAnyDemand: matchAnyDemand,
        matchAllDemand: matchAllDemand,
        matchTwoDemand: matchTwoDemand,
        resetPassword: resetPassword,
        confirmNewPassword: confirmNewPassword,
        getAuth0Token: getAuth0Token,
        getTokenExpired: getTokenExpired,
        refreshSession: refreshSession
    };

    function refreshSession(callback){
        var json = {
            token: apiToken.token
        }

        DSHttpAdapter.POST(DS.defaults.basePath + 'auth/refreshsession', json).then(function() {
            callback(true);
        },function(error) { 
            callback(false, error.data.message);
            ToasterService.showError(error.data.message, $translate.instant('common.error'));
        }).finally(function (){
        });
    }

    function getTokenExpired(){
        var deferred = $q.defer();
    
        var params = {};
        params.token = apiToken.token;

        DSHttpAdapter.GET(DS.defaults.basePath + 'auth/expire', {params : params}).then(function(response) {
            deferred.resolve(response);
        
        },function(error) { 
            deferred.reject(handleError(error));
        });
        
        return deferred.promise;//.$$state.value.data.expireDate;
    }

    function getAuth0Token() {
        var deferred = $q.defer();

        DSHttpAdapter.POST(DS.defaults.basePath + 'auth/auth0', {}).then(function(response) {
            deferred.resolve(response);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function isAuthenticated() {
        return _isAuthenticated;
    }

    function hasToken() {
        return angular.isDefined(apiToken.token) && apiToken.token !== null;
    }

    function canAccess(objectType, permission) {
        if (!isAuthenticated() || !_user.claims) { return false; }

        var lowerCaseObjectType = _.toLower(objectType);

        return _user.claims[lowerCaseObjectType] && (!permission || _user.claims[lowerCaseObjectType][permission]);
    }

    function hasUser() {
        return angular.isDefined(_user) && _user !== null;
    }

    function getUser() {
        var deferred = $q.defer();

        // If we already have the user, just return it
        if (hasUser()) {
            deferred.resolve(_user);
        } else {
            UsersApiService.getSelf().then(function(user) {
                var objectTypes = Object.keys(user.claims);
                var licenseTypes = Object.keys(user.licenseConfig);
                var claims = {};
                var licenseConfig = {};
                _.forEach(objectTypes, function(objectType) { claims[_.toLower(objectType)] = user.claims[objectType]; });
                _.forEach(licenseTypes, function(licenseType) { licenseConfig[_.toLower(licenseType)] = user.licenseConfig[licenseType]; });
                _user = user;
                _user.claims = claims;
                _user.licenseConfig = licenseConfig;
                _isAuthenticated = true;
                if (user.tenant && user.tenant.languageLocale) {
                    $translate.use(user.tenant.languageLocale);
                }
                $translate.refresh();
                deferred.resolve(_user);
            }, function() {
                expireSession();
                deferred.reject();
            });
        }

        return deferred.promise;
    }

    function showLogin(message) {
        if (!_isAuthenticating) {
            _isAuthenticating = true;
            LoginDialogService.showDialog({isLoginState:isLoginState(),authMessage:message}).then(function(result) {
                setToken(result.Token, result.Tenant);
                if (isLoginState()) {
                    // Go to the stated if it exists, else go to root url
                    if ($rootScope.toState !== null && $rootScope.toState.name !== "login") {
                        $state.go($rootScope.toState.name, $rootScope.toParams, {replace: true});
                    } else {
                        $location.path("/");
                    }
                }
            }).finally(function() {_isAuthenticating = false;});
        }
    }
    function logOut() {
        expireSession();
        // Reload the app
        $window.location.href = '/';
    }
    function expireSession() {
        apiToken.token = null;
        _user = null;
        _isAuthenticated = false;
        // Remove the cookie
        $cookies.remove('X-JetsoftToken');

        // Remove header
        DSHttpAdapter.defaults.httpConfig.headers = { Authorization: function() { return null;} };
    }
    function isLoginState() {
        return !!($rootScope.$state.current.abstract || $rootScope.$state.current.name === "login");
    }
    function setToken(token, tenantName) {
        if (token) {
            $cookies.putObject("X-JetsoftToken", token);
            $cookies.putObject("X-JetsoftTenant", tenantName);
            $cookies.putObject("x-cleverapps-tenant", tenantName);
        } else {
            token = $cookies.getObject('X-JetsoftToken');
            tenantName = $cookies.getObject('X-JetsoftTenant');
        }

        if (token) {
            apiToken.token = token;
            DSHttpAdapter.defaults.httpConfig.headers = { Authorization: apiToken.token, Tenant: tenantName };
            DSHttpAdapter.defaults.httpConfig.headers['x-cleverapps-tenant'] = tenantName;
        }
    }

    function matchAnyDemand(demand, rights) {
        for (var propertyName in demand) {

            if (!rights) {
                 continue;
            }
            var rightNode = rights[_.toLower(propertyName)];
            if (rightNode && demand[propertyName] === rightNode) {
                return true;
            }
            if (matchAnyDemand(demand[propertyName],rightNode)) {
                return true;
            }
        }
        return false;
    }

    function matchAllDemand(demand, rights) {
        for (var propertyName in demand) {
            var rightNode = rights[propertyName];
            if (!rightNode) {
                return false;
            }
            return matchAllDemand(demand[propertyName],rightNode);
        }
        return true;
    }

    //matchAllDemand dont work properly with the data from navigation.api.js   
    function matchTwoDemand(demand, rights, type, seepurchasecost, stock) {
        if(demand.hasOwnProperty(seepurchasecost) && demand.hasOwnProperty(stock) && type === 'leaf'){
            if(rights.seepurchasecost != undefined){
                if(!rights.seepurchasecost.read || !rights.stock.read){
                    return false
                }
            }
        }

       return true
    }

    function resetPassword(user) {
        var deferred = $q.defer();

        var param = {};
        param.tenantName = user.tenantName;
        if (user.username.length > 0) { param.username = user.username; }
        if (user.email.length > 0) { param.email = user.email; }

        DSHttpAdapter.POST(DS.defaults.basePath + 'auth/reset', param).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });
        return deferred.promise;
    }

    function confirmNewPassword(user) {
        var deferred = $q.defer();

        var param = {};
        param.tenantName = user.tenantName;
        param.newPassword = user.newPassword;
        param.confirmPassword = user.confirmPassword;
        param.securityCode = user.securityCode;

        DSHttpAdapter.POST(DS.defaults.basePath + 'auth/confirm', param).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });
        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('services.authService', [])
    .factory('AuthService', AuthService);
